import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en.js';
import { triggerFieldValidation } from './validateForm.js';
import { displayDateFormat } from '../../config.js';

export const initializeCalendarField = (field) => {
    if (!field) return;

    // The plugin offered both daysShort and daysMin, but statically set to daysMin and no config to use daysShort
    localeEn.default.daysMin = localeEn.default.daysShort;

    const picker = new AirDatepicker(field, {
        locale: localeEn.default,
        autoClose: true,
        minDate: new Date(),
        dateFormat: displayDateFormat,
        onSelect: (date) => {
            // Set the value in the format required by Wheelform for submission
            field.value = date.formattedDate;
            triggerFieldValidation(field);
        }
    });
};
